import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { styleMap as o$2 } from '../../../../node_modules/lit-html/directives/style-map.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import { queryAssignedElements as l } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o$1 } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { getCookie } from '../../utilities/backend-helpers/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { TabsOrientation } from './enums.js';
import css_248z from './tabs.scss.js';

class Tabs extends s {
    constructor() {
        super(...arguments);
        this.orientation = TabsOrientation.VERTICAL;
        this.rtl = false;
        this.visibleScroll = false;
        this.pointerShift = '0px';
        this.gatedContent = null;
        this.pointerWidth = '0px';
    }
    setActiveTab(selectedTab) {
        if (!selectedTab || selectedTab.selected)
            return;
        const prevActiveTab = this.tabs.find(tab => tab.selected);
        const newActiveTab = this.tabs.find(tab => tab === selectedTab);
        if (prevActiveTab)
            prevActiveTab.selected = false;
        if (newActiveTab) {
            newActiveTab.selected = true;
            const ActiveTabChild = newActiveTab.querySelector('tab-item countries-list country-link a');
            if (ActiveTabChild) {
                setTimeout(() => {
                    ActiveTabChild.focus();
                }, 100);
            }
            this.requestUpdate();
        }
    }
    firstUpdated() {
        const pageHash = window.location.hash.substring(1);
        const anchorTabIndex = this.tabs.findIndex(tab => tab.id && tab.id === pageHash);
        if (anchorTabIndex > -1) {
            const tab = this.tabs[anchorTabIndex];
            if (tab.tabId) {
                this.setActiveTab(this.tabs[0]);
                this.handleRestrictedContent(tab, true);
                return;
            }
            this.setActiveTab(tab);
            setTimeout(() => {
                this.scrollIntoView();
            }, 1000);
        }
        else {
            this.setActiveTab(this.tabs[0]);
        }
    }
    updated() {
        const activeButton = this.shadowRoot.querySelector('nav button.selected');
        setTimeout(() => {
            this.pointerWidth = `${(activeButton === null || activeButton === void 0 ? void 0 : activeButton.clientWidth) || 0}px`;
            if (this.rtl || isRTL()) {
                const navWidth = this.renderRoot.querySelector('.nav-list').clientWidth;
                this.pointerShift = `${navWidth -
                    ((activeButton === null || activeButton === void 0 ? void 0 : activeButton.offsetLeft) || 0) -
                    ((activeButton === null || activeButton === void 0 ? void 0 : activeButton.clientWidth) || 0)}px`;
            }
            else {
                this.pointerShift = `${(activeButton === null || activeButton === void 0 ? void 0 : activeButton.offsetLeft) || 0}px`;
            }
        }, 50);
    }
    handleRestrictedContent(tab, onFirstUpdated = false) {
        var _a;
        this.gatedContent = document.querySelector(`restricted-content[tabid="${tab.tabId}"]`);
        const allowBtn = (_a = this.gatedContent) === null || _a === void 0 ? void 0 : _a.querySelector('generic-button[allow] button');
        if (getCookie(`gated-tab-${tab.tabId}`) === '0' && !onFirstUpdated)
            return;
        if (getCookie(`gated-tab-${tab.tabId}`) === '0' && onFirstUpdated) {
            this.setActiveTab(this.tabs[0]);
            return;
        }
        if (getCookie(`gated-tab-${tab.tabId}`) === '1') {
            this.setActiveTab(tab);
            return;
        }
        this.gatedContent.showContent();
        allowBtn === null || allowBtn === void 0 ? void 0 : allowBtn.addEventListener('click', () => this.setActiveTab(tab));
    }
    handleTabClick(tab) {
        if (tab.redirectUrl) {
            window.location = tab.redirectUrl;
        }
        if (!tab.tabId)
            this.setActiveTab(tab);
        if (tab.tabId)
            this.handleRestrictedContent(tab);
    }
    renderTab(tab) {
        return x `<button class="${o({ selected: tab.selected })}" @click="${() => this.handleTabClick(tab)}" name="${tab.name}"><span class="tab-text">${o$1(tab.name)}</span></button>`;
    }
    render() {
        const rtl = this.rtl || isRTL();
        const navClassMap = {
            'tabs-nav': true,
            [`tabs-${this.orientation}`]: true,
            'visible-scroll': this.visibleScroll,
            rtl,
        };
        const pointerStyleMap = o$2({
            left: rtl ? '0px' : this.pointerShift,
            right: rtl ? this.pointerShift : '0px',
            width: this.pointerWidth,
        });
        return x `<nav class="${o(navClassMap)}"><div class="nav-list">${this.tabs.map(tab => this.renderTab(tab))}<div class="pointer" style="${pointerStyleMap}"></div></div></nav><div class="content"><slot></slot></div>`;
    }
}
Tabs.styles = css_248z;
__decorate([
    l({ slot: '', flatten: true, selector: 'tab-item' })
], Tabs.prototype, "tabs", void 0);
__decorate([
    n({ type: String })
], Tabs.prototype, "orientation", void 0);
__decorate([
    n({ type: Boolean })
], Tabs.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], Tabs.prototype, "visibleScroll", void 0);
__decorate([
    t()
], Tabs.prototype, "pointerShift", void 0);
__decorate([
    t()
], Tabs.prototype, "gatedContent", void 0);
__decorate([
    t()
], Tabs.prototype, "pointerWidth", void 0);
customElements.define('tabs-container', Tabs);

export { Tabs };
